import { useContext, useEffect, useState } from "react";
import { MdArrowOutward } from "react-icons/md";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { aboutHighlights, company, operationalStrengths } from "../siteContent";

export default function HomeBanner2(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="MainBodySection tff-gradient-section">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-7">
            <div className="tff-section-kicker tff-section-kicker-light">About The Company</div>
            <h2 className="font-light text-light tff-banner-title mt-3">{company.shortName}</h2>
            <p className="font-light text-light tff-banner-copy">
              {company.shortName} is a professionally managed tour company based in Zanzibar, dedicated to delivering
              high-quality, personalized travel across Zanzibar Island and mainland Tanzania. We serve leisure travelers,
              groups, corporate clients, and special-interest guests looking for authentic and well-managed experiences.
            </p>

            <div className="row g-3 mt-2">
              {aboutHighlights.map((item) => (
                <div key={item.label} className="col-md-4">
                  <div className="tff-highlight-card">
                    <p className="font-light mb-1">{item.label}</p>
                    <h6 className="font-semi-bold mNoMargin">{item.value}</h6>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="btn btn-secondary btn-rounded btn-padded mt-4"
              onClick={() => {
                appContext.navTo({ item: "about_us" });
              }}
            >
              Learn More About Us
              <MdArrowOutward size={18} className="ms-2" />
            </button>
          </div>

          <div className="col-lg-5">
            <div className="tff-glass tff-strength-card">
              <p className="font-semi-bold text-secondary mb-3">Operational strengths</p>
              {operationalStrengths.slice(0, 5).map((item) => (
                <div key={item} className="tff-plain-check-item text-light">
                  <span className="tff-plain-check-dot"></span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
